import { Component } from "vue-property-decorator";
import Vue, { nextTick } from "vue";
import axios from "axios";
import { EmployeeModel } from "@/models/employeeModels";

@Component({})
export default class dashboardEmployee extends Vue {
  item: EmployeeModel = new EmployeeModel();

  isLoading: boolean = false;
  pbiUrl: string = null;

  // fetch(): void {
  //   var instance = this;
  //   instance.isLoading = true;
  //   axios
  //     .get<EmployeeModel>("employee/me")
  //     .then(res => {
  //       instance.item = res.data ? res.data : new EmployeeModel();
  //       instance.isLoading = false;
  //     })
  //     .catch(error => {
  //       console.error(error);
  //       instance.isLoading = false;
  //     });
  // }

  async fetch(): Promise<void> {
    var instance = this;
    instance.isLoading = true;

    try {
      var res = await axios.get<EmployeeModel>("employee/me");

      instance.item = res.data ? res.data : new EmployeeModel();

      //instance.item.urlPowerBI = "https://www.k-digitale.com";

      nextTick(() => {
        if (instance.item && instance.item.urlPowerBI != null) {

          var iframe = document.getElementById("pbi-iframe");
          iframe.parentNode.parentElement.style.height = "100%";
          iframe.parentElement.style.height = "100%";
          instance.pbiUrl = instance.item.urlPowerBI;
        }
      })
      
      instance.isLoading = false;
    } catch (error) {
      console.error(error);
      instance.isLoading = false;
    }
  }

  async mounted() {
    var instance = this;
    
    await instance.fetch();
  }
}
